import React from "react";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";
import App from "./App";
import "./index.css";
import "slick-carousel/slick/slick.css";
import MediumWoff2 from './assets/fonts/1587404/1b584af2-4749-4520-9408-8fce94f2e5d3.woff2';
import RegularWoff2 from './assets/fonts/1587546/cdd3ff94-988b-44c6-b08e-574f160cc0d1.woff2';
import BoldWoff2 from './assets/fonts/1588725/2ab8d198-2910-441a-b1d1-9aed52f66e49.woff2';

[MediumWoff2, RegularWoff2, BoldWoff2].forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'font';
  link.href = href;
  link.type = 'font/woff2';
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});

// Load GTM on the production domain (including www and subdomains).
if (
  window.location.hostname === "yelofunding.com" ||
  window.location.hostname.endsWith(".yelofunding.com")
) {
  TagManager.initialize({
    gtmId: "GTM-NP6PW47T",
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
